import { roundDecimalValue } from '@common/utils';
import { Notification } from '@components';
import { customerStore, orderStore } from '@store/orders';
import { customerPay, totalOrderExpenses } from '@utils/calculateLineItems';
import { Accessor, Component, Index, Setter, createEffect } from 'solid-js';

type CustomerWarningsProps = {
  customerWarnings: Accessor<string[] | null>;
  setCustomerWarnings: Setter<string[] | null>;
};

const CustomerWarnings: Component<CustomerWarningsProps> = (
  props: CustomerWarningsProps,
) => {
  createEffect(() => {
    const { id, status, available, paymentTerms } = customerStore.customer;
    const { order } = orderStore;
    const warnings = [];

    if (!id) {
      props.setCustomerWarnings(null);
      return;
    }

    if (id) {
      if (status === 'Inactive') {
        warnings.push('Customer is Inactive');
      }
      if (status === 'Duplicate') {
        warnings.push('Customer is Duplicate');
      }
      if (status === 'Dormant') {
        warnings.push('Customer is Dormant');
      }
      if (status === 'Deactivated') {
        warnings.push('Customer is Deactivated');
      }
      if (status === 'Bankruptcy') {
        warnings.push('Customer is Bankrupt');
      }
      if (status === 'Credit Review') {
        warnings.push('Customer is Credit Review');
      }
      if (status === 'RFP') {
        warnings.push('Customer is RFP');
      }
      if (['Credit Hold', 'Collection Hold'].includes(status)) {
        warnings.push(
          'Customer is on hold due to non payment, please reach out to A/R.  New Loads cannot be created.',
        );
      }
      if (status === 'In Collections' && !order.id) {
        warnings.push(
          'Customer is in Collections, new loads cannot be created',
        );
      }
      if (available < totalOrderExpenses() && order.id === 0) {
        warnings.push('Customer has insufficient Credit for this Order');
      }
      const prePaymentsTotal = order.customerPrePayments
        ? getPrePaymentsTotal()
        : 0;
      if (
        paymentTerms === 'Prepay' &&
        outstandingBalance() - prePaymentsTotal > 0
      ) {
        warnings.push(
          'Customer is marked as prepay.  You Must obtain payment before proceeding with any loads.',
        );
      }
      if (warnings.length > 0) {
        props.setCustomerWarnings(warnings);
      } else {
        props.setCustomerWarnings(null);
      }
    }
  });

  const outstandingBalance = () => {
    return customerPay() - paymentsTotal();
  };

  const getPrePaymentsTotal = () => {
    const unprocessedPayments = (
      orderStore.order.customerPrePayments || []
    ).filter((p) => p.processed == false);
    const total = unprocessedPayments.reduce((accumulator, payment) => {
      return accumulator + payment.paidAmount;
    }, 0);
    return total;
  };

  const paymentsTotal = () => {
    return orderStore.order.payments.length > 0
      ? orderStore.order.payments.reduce(
          (acc, item) => acc + roundDecimalValue(item.amount, 2),
          0,
        )
      : 0;
  };

  return (
    <>
      {(props.customerWarnings()?.length ?? 0) > 0 && (
        <div class="flex flex-col gap-2 mb-4">
          <Index each={props.customerWarnings()}>
            {(item: Accessor<string>) => (
              <Notification type="error" text={item()} />
            )}
          </Index>
        </div>
      )}
    </>
  );
};

export default CustomerWarnings;
